<script>
  import { createProps, defaultValue, getComponent, getComponentProps } from '../helpers'

  const p = createProps();
  export let value = p.value;
  export let errors = p.errors;
  export let schema = p.schema;
  export let components = p.components;
  export let props = p.props;
  export let key = p.key;
  /* recalc a default value */
  if (schema && value == null) {
      value = defaultValue(schema, value);
  }
</script>

{#if schema && components}
  <svelte:component
    this={getComponent(components.wrapper)}
    {...getComponentProps(components.wrapper)}
    {schema}
    {key}
    {errors}>
    <input {...props} class="form-input" type="number" step={props.step || 'any'} bind:value />
  </svelte:component>
{/if}
